import { render, staticRenderFns } from "./TemlikList.vue?vue&type=template&id=4149f3ef"
import script from "./TemlikList.vue?vue&type=script&lang=ts"
export * from "./TemlikList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports